export default class AutoScroll {
    constructor() {
        this.keyframes = {
            show: { opacity: 1 },
            scroll: { translate: '-100%' },
        };

        this.showOptions = { duration: 600, fill: 'forwards' };

        this._init();
    }

    _init() {
        this._getEl();
    }

    _getEl() {
        this.$autoSscroll = document.querySelector('.js-auto-scroll');
        this.$inner = this.$autoSscroll.querySelector('.js-auto-scroll__inner');
    }

    appendInner() {
        if (!this.$autoSscroll || !this.$inner) return;

        this.innerWidth = this.$inner.clientWidth;
        const innerNum = Math.ceil(this.$autoSscroll.clientWidth / this.innerWidth);

        for (let i = 0; i < innerNum; i++) {
            this.$autoSscroll.append(this.$inner.cloneNode(true));
        }

        const $innerArr = [...this.$autoSscroll.querySelectorAll('.js-auto-scroll__inner')];
        $innerArr.forEach($inner => this._setAnimateShow($inner));
    }

    _setAnimateShow($inner) {
        const animateShow = $inner.animate(this.keyframes.show, this.showOptions);
        animateShow.onfinish = () => this._setAnimateScroll($inner);
    }

    _setAnimateScroll($inner) {
        const options = { duration: this.innerWidth * 28.5, iterations: Infinity },
            animateScroll = $inner.animate(this.keyframes.scroll, options);
    }
}
